<template>
  <h1>
    GLOSSARY
  </h1>
  <ul>
    <li><b><u>World</u></b> - Set of rules, properties and descriptions that describe the background rules for the world.</li>
    <li><b><u>Game</u></b> - A game that is based on certain World. We can have a multiple games with uniq settings based on the same World.</li>
    <li><b><u>TBBG</u></b> - Text Based Browser Game. The game that runs on the browser and the main medium is text. We believe that players need some self space to imagine a lot of things. The same goes whenever you read a book. That makes your experience uniq for you. There is no way some polished art will have the same impact on all the players. But self imaged things may do the work :)</li>
  </ul>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  components: {}
})
export default class Glossary extends Vue {}
</script>

<style scoped>
ul {
  list-style-type: none;
}
ul li {
  margin-bottom: 20px;
}
</style>
